import {
    API_ROUTE,
    CONFORMIO_APP_URL,
    CONFORMIO_API_URL
} from '@/constants'

let config = {
    getTinymceApiKey () {
        return process.env.VUE_APP_TINYMCE_API_KEY || ''
    },
    getApiUrl () {
        return CONFORMIO_API_URL + API_ROUTE
    },

    getAppUrl () {
        return CONFORMIO_APP_URL
    },

    getHostName () {
        return CONFORMIO_API_URL
    },

    isProductionEnv () {
        return process.env.NODE_ENV === 'production'
    }
}

export { config }
